import './resourceViewDrilldown.scss'
import templateUrl from './resourceViewDrilldown.html'

/**
 * component
 *
 * @example
 * <tmr-resource-view-header
 *   resource="$ctrl.resource"
 * ></tmr-resource-view-header>
 *
 * @type {ngComponent}
 * @prop {array} resource-details
 */
export const tmrResourceViewDrilldown = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrResourceViewDrilldownController',
  bindings: {
    drilldownParts: '<',
  },
}

/**
 * Controller of component {@link tmrResourceViewDrilldown}.
 *
 * @type {ngController}
 */
export class tmrResourceViewDrilldownController {
  static ngType = 'controller'

  $onInit() {
    // Add params for ui-sref.
    // Each part sets the params of itself and all following parts to null.
    this.drilldownParts.forEach((part, idx) => {
      part.params = {}
      this.drilldownParts.slice(idx).forEach(p => {
        if (p.param) part.params[p.param] = null
      })
    })
  }
}
